import { render } from "./TopPane.vue?vue&type=template&id=167a3463&scoped=true"
import script from "./TopPane.vue?vue&type=script&lang=js"
export * from "./TopPane.vue?vue&type=script&lang=js"

import "./TopPane.vue?vue&type=style&index=0&id=167a3463&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167a3463"]])

export default __exports__